const iconButton = {
  styleOverrides: {
    root: {
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0)",
      },
    },
  },
};

export default iconButton;
